// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a1521351","455":"0699d545","977":"d89e88c4"}[chunkId] + ".chunk.js";
};